import React from "react";
import "./LoaderButton.css"


export default({
  isLoading,
  text,
  loadingText,
  className = "",
  disabled = false,
  ...props
}) =>
    <button className={`LoaderButton ${className}`}
            
            {...props}>

          {!isLoading ? text : loadingText }
          {isLoading && <i className="fa fa-refresh fa-spin fa-2x"></i> }
    </button>



// WEBPACK FOOTER //
// ./src/components/LoaderButton.js